/* // components/UI/ConfirmModal.jsx
import Button from "./Button";

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel, isLoading }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl transform animate-in zoom-in-95 duration-200">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mb-4">
            <span className="text-3xl">⚠️</span>
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">{title || "Are you sure?"}</h3>
          <p className="text-gray-500 text-sm mb-6">{message || "This action cannot be undone."}</p>
          
          <div className="flex gap-3 w-full">
            <Button 
              variant="secondary" 
              onClick={onCancel} 
              className="flex-1"
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button 
              variant="danger" 
              onClick={onConfirm} 
              className="flex-1"
              isLoading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
} */
//   import { motion, AnimatePresence } from "framer-motion";
//   import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
//   import Button from "./Button";
  
//   export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel, isLoading }) {
//     return (
//       <AnimatePresence>
//         {isOpen && (
//           <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
//             {/* الخلفية المعتمة مع أنيميشن الدخول والخروج */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               animate={{ opacity: 1 }}
//               exit={{ opacity: 0 }}
//               onClick={!isLoading ? onCancel : null}
//               className="absolute inset-0 bg-black/50 backdrop-blur-sm"
//             />
  
//             {/* جسم المودال المدعوم بالأنيميشن الفيزيائي */}
//             <motion.div
//               initial={{ scale: 0.9, opacity: 0, y: 20 }}
//               animate={{ scale: 1, opacity: 1, y: 0 }}
//               exit={{ scale: 0.9, opacity: 0, y: 15 }}
//               transition={{ type: "spring", damping: 25, stiffness: 400 }}
//               className="relative bg-white rounded-[2rem] p-8 max-w-sm w-full shadow-2xl z-10"
//             >
//               <div className="flex flex-col items-center text-center">
//                 {/* الأيقونة مع تأثير حركة تنبيه (Shake + Pulse) */}
//                 <motion.div 
//                   animate={{ 
//                     scale: [1, 1.1, 1],
//                     rotate: [0, 5, -5, 0] 
//                   }}
//                   transition={{ duration: 2, repeat: Infinity }}
//                   className="w-20 h-20 bg-red-50 text-red-500 rounded-[1.5rem] flex items-center justify-center mb-6"
//                 >
//                   <ExclamationTriangleIcon className="w-12 h-12" />
//                 </motion.div>
  
//                 <h3 className="text-2xl font-bold text-gray-800 mb-2">
//                   {title || "Are you sure?"}
//                 </h3>
                
//                 <p className="text-gray-500 text-sm leading-relaxed mb-8">
//                   {message || "This action cannot be undone. Please confirm to proceed."}
//                 </p>
                
//                 {/* استخدام أزرار النظام الخاص بك */}
//                 <div className="flex gap-4 w-full">
//                   <Button 
//                     variant="secondary" 
//                     onClick={onCancel} 
//                     className="flex-1 !rounded-xl"
//                     disabled={isLoading}
//                   >
//                     Cancel
//                   </Button>
//                   <Button 
//                     variant="danger" 
//                     onClick={onConfirm} 
//                     className="flex-1 !rounded-xl shadow-lg shadow-red-100"
//                     isLoading={isLoading}
//                   >
//                     Confirm
//                   </Button>
//                 </div>
//               </div>
//             </motion.div>
//           </div>
//         )}
//       </AnimatePresence>
//     );
//   }

/* import { motion, AnimatePresence } from "framer-motion";
import { ExclamationTriangleIcon, CheckCircleIcon } from "@heroicons/react/24/outline";
import Button from "./Button";
import { useState, useEffect } from "react";

export default function ConfirmModal({ isOpen, title, message, onConfirm, onCancel, isLoading, isSuccess }) {
  
  // أنيميشن الاهتزاز عند التنبيه
  const shakeAnimation = {
    rotate: [0, -5, 5, -5, 5, 0],
    transition: { duration: 0.4 }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={(!isLoading && !isSuccess) ? onCancel : null}
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
          />

          <motion.div
            layout // يجعل تغيير الحجم بين الحالات يظهر بانسيابية
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 15 }}
            className="relative bg-white rounded-[2.5rem] p-8 max-w-sm w-full shadow-2xl z-10 overflow-hidden"
          >
            <AnimatePresence mode="wait">
              {!isSuccess ? (
                // --- حالة التأكيد (Confirmation State) ---
                <motion.div
                  key="confirm"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 20 }}
                  className="flex flex-col items-center text-center"
                >
                  <motion.div 
                    animate={isOpen ? { scale: [1, 1.1, 1] } : {}}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="w-20 h-20 bg-red-50 text-red-500 rounded-3xl flex items-center justify-center mb-6"
                  >
                    <ExclamationTriangleIcon className="w-12 h-12" />
                  </motion.div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{title || t("confirm_default_title", "Are you sure?")}</h3>
                  <p className="text-gray-500 text-sm mb-8 leading-relaxed">{message || t("confirm_default_message", "This action cannot be undone.")}</p>

                  <div className="flex gap-3 w-full">
                    <Button variant="secondary" onClick={onCancel} className="flex-1 !rounded-2xl" disabled={isLoading}>
                      {t("btn_cancel", "Cancel")}
                    </Button>
                    <Button variant="danger" onClick={onConfirm} className="flex-1 !rounded-2xl shadow-lg shadow-red-100" isLoading={isLoading}>
                      {t("btn_delete", "Delete")}
                    </Button>
                  </div>
                </motion.div>
              ) : (
                // --- حالة النجاح (Success State) ---
                <motion.div
                  key="success"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  className="flex flex-col items-center text-center py-4"
                >
                  <motion.div 
                    initial={{ scale: 0 }}
                    animate={{ scale: 1.2, rotate: 360 }}
                    transition={{ type: "spring", damping: 10, stiffness: 100 }}
                    className="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mb-6"
                  >
                    <CheckCircleIcon className="w-14 h-14" />
                  </motion.div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">Deleted!</h3>
                  <p className="text-gray-500 text-sm">The item has been removed successfully.</p>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
} */

  import { motion, AnimatePresence } from "framer-motion";
import { ExclamationTriangleIcon, CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import Button from "./Button";
import { useTranslation } from "../../context/I18nContext";

export default function ConfirmModal({
  isOpen, title, message, onConfirm, onCancel, isLoading, isSuccess, isError,
  // Every prop below defaults to this modal's ORIGINAL delete-confirmation
  // behavior, unchanged, so every pre-existing caller (there are dozens —
  // Categories/Products/Branches/etc. all confirm a plain delete) keeps
  // working with zero changes. They only matter to a caller confirming
  // something that ISN'T a delete — Receive/Cancel Purchase Order, Void
  // Expense, Void Journal Entry, and any future one — which is exactly the
  // case this modal used to get wrong: the confirm button always read
  // "Delete" and the success screen always read "Deleted!" regardless of
  // what action was actually being confirmed (see e.g.
  // ViewPurchaseOrder.js's Receive Purchase Order flow, which surfaced
  // this — a button reading "Delete" right under a message about adding
  // stock to a branch).
  confirmLabel,
  confirmVariant = "danger",
  successTitle,
  successMessage,
}) {
  // "common" is the single shared namespace for reusable action words/UI
  // chrome (see internal/config/seed_translations.go's own "common" block)
  // — every caller of this modal gets these for free instead of each page
  // needing its own Cancel/Delete/"Are you sure?" translation keys.
  const { t } = useTranslation("common");

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={(!isLoading && !isSuccess && !isError) ? onCancel : null}
            className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm"
          />

          <motion.div
            layout
            initial={{ scale: 0.9, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 15 }}
            className="relative bg-white rounded-[2.5rem] p-8 max-w-sm w-full shadow-2xl z-10 overflow-hidden"
          >
            <AnimatePresence mode="wait">
              {/* 1. حالة النجاح (Success) */}
              {isSuccess ? (
                <motion.div
                  key="success"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  className="flex flex-col items-center text-center py-4"
                >
                  <motion.div 
                    initial={{ scale: 0 }}
                    animate={{ scale: 1.2, rotate: 360 }}
                    transition={{ type: "spring", damping: 10, stiffness: 100 }}
                    className="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mb-6"
                  >
                    <CheckCircleIcon className="w-14 h-14" />
                  </motion.div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{successTitle || t("confirm_deleted_title", "Deleted!")}</h3>
                  <p className="text-gray-500 text-sm">{successMessage || t("confirm_deleted_message", "The item has been removed successfully.")}</p>
                </motion.div>
              )
              /* 2. حالة الفشل (Error) - التأثير الذي طلبته */
              : isError ? (
                <motion.div
                  key="error"
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.8 }}
                  className="flex flex-col items-center text-center py-4"
                >
                  <motion.div 
                    initial={{ scale: 0 }}
                    animate={{ scale: 1, x: [0, -10, 10, -10, 10, 0] }} // أنيميشن اهتزاز عند الظهور
                    transition={{ type: "spring", damping: 8, stiffness: 100, x: { duration: 0.4, delay: 0.2 } }}
                    className="w-20 h-20 bg-red-50 text-red-500 rounded-full flex items-center justify-center mb-6"
                  >
                    <XCircleIcon className="w-14 h-14" />
                  </motion.div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{t("confirm_failed_title", "Failed!")}</h3>
                  <p className="text-gray-500 text-sm mb-6">{t("confirm_failed_message", "Something went wrong. Please try again later.")}</p>
                  <Button variant="secondary" onClick={onCancel} className="w-full !rounded-2xl">
                    {t("btn_close", "Close")}
                  </Button>
                </motion.div>
              ) 
              /* 3. حالة التأكيد (Confirmation) - الحالة الأصلية */
              : (
                <motion.div
                  key="confirm"
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: 20 }}
                  className="flex flex-col items-center text-center"
                >
                  <motion.div 
                    animate={{ scale: [1, 1.1, 1] }}
                    transition={{ duration: 2, repeat: Infinity }}
                    className="w-20 h-20 bg-red-50 text-red-500 rounded-3xl flex items-center justify-center mb-6"
                  >
                    <ExclamationTriangleIcon className="w-12 h-12" />
                  </motion.div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{title || t("confirm_default_title", "Are you sure?")}</h3>
                  <p className="text-gray-500 text-sm mb-8 leading-relaxed">{message || t("confirm_default_message", "This action cannot be undone.")}</p>

                  <div className="flex gap-3 w-full">
                    <Button variant="secondary" onClick={onCancel} className="flex-1 !rounded-2xl" disabled={isLoading}>
                      {t("btn_cancel", "Cancel")}
                    </Button>
                    <Button variant={confirmVariant} onClick={onConfirm} className="flex-1 !rounded-2xl shadow-lg shadow-red-100" isLoading={isLoading}>
                      {confirmLabel || t("btn_delete", "Delete")}
                    </Button>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}